<template>
  <div id="app">
    <!-- <PHbanner /> -->
    <Header />
    <div class="content-wrapper">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
// import PHbanner from "@/components/common/PHbanner.vue";
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

export default {
  name: 'Home',
  components: {
    // PHbanner,
    Header,
    Footer
  }
}
</script>

<style lang="scss">
@media (max-width: 601px) {
  #cta44181 {
    display: none !important;
  }
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  flex: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
